

import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class TimelogService {

    static getTimelogsListResult(CompanyCode, list, ActionType, Duplicates) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType: ActionType,
            Duplicates: Duplicates
        }  
        return axios.post(BaseUrl +'Timelogs', data);
    }

    static SaveTimelog(CompanyCode, list,ActionType, email) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType: ActionType
        }  
        return axios.post( BaseUrl + 'SaveTimelog?email='+email, data);
    }
}



// WEBPACK FOOTER //
// ./src/Services/TimelogService/timelogService.js